import i18n from '@/i18n/i18n'
import RetailerService from '@/services/admin/RetailerService'
import SupplierService from '@/services/admin/SupplierService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

import { SUPPLIER_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const allowedFilters = ['title', 'by_type', 'address.city.region_id', 'address.city_id']
export const allowedIncludes = ''
export const allowedSorts = '-created_at'
export const allowedAppends = ''

export const namespaced = true

export const state = {
  suppliers: [],
  supplier: {},
  meta: null,
  retailer: null,
  productSuppliers: [],
  transportSuppliers: []
}
export const mutations = {
  SET_SUPPLIERS(state, suppliers) {
    state.suppliers = suppliers.data
    state.productSuppliers = suppliers.data.filter(supplier => supplier.types.includes(1))
    state.transportSuppliers = suppliers.data.filter(supplier => supplier.types.includes(2))
    state.meta = suppliers.meta
  },
  SET_SUPPLIER(state, supplier) {
    state.supplier = supplier
  },
  ADD_SUPPLIER(state, supplier) {
    if (supplier.types.includes(1)) {
      state.productSuppliers.push(supplier)
    } else if (supplier.types.includes(2)) {
      state.transportSuppliers.push(supplier)
    }
    state.suppliers.push(supplier)
  },
  SET_RETAILER(state, retailer) {
    state.retailer = retailer.data
  },
  SET_SUPPLIER_TYPE(state, supplier) {
    state.supplier.types = supplier.types
  }
}

export const actions = {
  getSuppliers({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)

    return new Promise((resolve, reject) => {
      SupplierService.getSuppliers(newQuery)
        .then(response => {
          commit('SET_SUPPLIERS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_ERROR_MESSAGES.getSuppliersError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getSuppliersWithoutUpdateStore({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)

    return new Promise((resolve, reject) => {
      SupplierService.getSuppliers(newQuery)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_ERROR_MESSAGES.getSuppliersError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getSupplier({ commit, getters, state }, payload) {
    return new Promise(resolve => {
      SupplierService.getSupplier(payload).then(response => {
        commit('SET_SUPPLIER', response.data)
        resolve(response.data)
      })
    })
  },
  createSupplier({ dispatch, commit, state }, supplier) {
    return new Promise((resolve, reject) => {
      SupplierService.createSupplier(supplier)
        .then(response => {
          if (state.suppliers) {
            commit('ADD_SUPPLIER', response.data)
          }

          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.suppliers.supplier')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  editSupplier({ dispatch, commit }, supplier) {
    return new Promise((resolve, reject) => {
      SupplierService.editSupplier(supplier.id, supplier)
        .then(response => {
          commit('SET_SUPPLIER', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.suppliers.supplier')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_ERROR_MESSAGES.editSupplierError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getRetailerByTin({ commit, dispatch }, tin) {
    return new Promise((resolve, reject) => {
      RetailerService.getRetailerByTin(tin).then(response => {
        commit('SET_RETAILER', response)
        resolve(response)
      })
    })
  },
  editSupplierType({ dispatch, commit }, supplier) {
    return new Promise((resolve, reject) => {
      SupplierService.editSupplierType(supplier.id, supplier.supplierType)
        .then(response => {
          commit('SET_SUPPLIER_TYPE', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.suppliers.supplier')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_ERROR_MESSAGES.editSupplierError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
